import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CandidateService {

  private readonly baseApiRoute = `${environment.apiBaseUrl}`;

  constructor(private http: HttpClient) { }

  public addCandidate(empReq: any[]): Observable<any> {
    return this.http.post<any[]>(`${this.baseApiRoute}CandidateRequest`, empReq);
  }

  public updateCandidate(empReq: any[]): Observable<any> {
    return this.http.put<any[]>(`${this.baseApiRoute}CandidateRequest/update`, empReq);
  }

  public getCadidateActive(): Observable<any> {
    return this.http.get<any>(`${this.baseApiRoute}CandidateRequest/getActive`);
  }

  public getManpowerRequisition(StatusId: number[], type : string): Observable<any> {
    const statusIDParams = StatusId.join(',');
    return this.http.get<any>(`${this.baseApiRoute}CandidateRequest/manpower-requisition-by-statusid?StatusId=${statusIDParams}&type=${type}`);
  }

  public CandidateUpdateStatus(empReq: any[]): Observable<any> {
    return this.http.post<any[]>(`${this.baseApiRoute}CandidateRequest/Update-Status`, empReq);
  }


  // Candidate Profile service

  public addCandidateProfile(CandidateDetails: any[]): Observable<any> {
    return this.http.post<any[]>(`${this.baseApiRoute}CandidateProfile`, CandidateDetails);
  }

  public UpdateEmployeeStatus(CandidateProfile: any[]): Observable<any> {
    return this.http.put<any[]>(`${this.baseApiRoute}CandidateProfile/EmployeeStatus`, CandidateProfile);
  }

  public getCadidateProfileActive(): Observable<any> {
    return this.http.get<any>(`${this.baseApiRoute}CandidateProfile/getActive`);
  }

  public getCadidateProfileManual(): Observable<any> {
    return this.http.get<any>(`${this.baseApiRoute}CandidateProfile/GetCandidateProfileManual`);
  }

  public updateCadidateProfileStatus(CandidateProfile: any): Observable<any> {
    return this.http.put<any>(`${this.baseApiRoute}CandidateProfile/Update-Status`,CandidateProfile);
  }
 
  public getCandidateProfileByReviewStatusCandidateStatusId(ReviewStatus:string,CandidateStatusId:string,type :string): Observable<any> {
    return this.http.get<any>(`${this.baseApiRoute}CandidateProfile/getCandidateProfileByReviewStatusCandidateStatusId?ReviewStatus=${ReviewStatus}&CandidateStatusId=${CandidateStatusId}&type=${type}`);
  }

  public updateCadidateProfileDoc(CandidateProfile: any): Observable<any> {
    return this.http.put<any>(`${this.baseApiRoute}CandidateProfile/UpdateCandidateProfileOffer`,CandidateProfile);
  }


  public VerifyCandidateProfileLogin(UserName: any, Password : any): Observable<any> {
    return this.http.get<any>(`${this.baseApiRoute}CandidateProfile/VerifyCandidateLogin?UserName=${UserName}&Password=${Password}`);
  }

  //Candidate Profile Overview Tab
  public getCandidateProOverviewTab(CandidateProfileId: number): Observable<any> {
     return this.http.get<any>(
      `${this.baseApiRoute}CandidateProfile/CandidateProfileOverviewById`,
      { params: { CandidateProfileId: CandidateProfileId.toString() } }
    );
  }

  public GetScreeningResumeDetails(ScreeningReq : any): Observable<any> {
    return this.http.post<any>(`${this.baseApiRoute}CandidateProfile/GetScreeningResumeDetails`, ScreeningReq);
  }


}
